exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".ReportFormalNoticeForProviderModal-datePicker-_jzPz{text-align:center}", ""]);

// exports
exports.locals = {
	"datePicker": "ReportFormalNoticeForProviderModal-datePicker-_jzPz"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?localIdentName=[name]-[local]-[hash:base64:5]!./~/autoprefixer-loader!./~/less-loader!./lib/ticket/components/ReportFormalNoticeForProviderModal.less
// module id = 1769
// module chunks = 0